<template>
  <div class="step__block-field">
    <h3>SUBTOTAL:</h3>

    <div class="step__block-field-price container">
      <PriceValue
        :price="estimateSubtotal"
        class="step__block-field-price old-price"
      />
      <PriceValue
        :price="subtotalPrice"
        class="step__block-field-price right"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { useEstimateReviewStore } from "@/stores/new/estimateReview.store";

import { Pricing } from "@/app/domain";

import { PricingService } from "@/app/services/pricing.service";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { PriceValue } from "@/shared";
import { useInstallationStore } from "@/stores/new/installation.store";
import { useDeliveryStore } from "@/stores/new/delivery.store";

const estimateStore = useNewEstimateStore();
const estimateReviewStore = useEstimateReviewStore();
const deliveryStore = useDeliveryStore();
const installationStore = useInstallationStore();

const subtotalPrice = computed(() => estimateReviewStore.subtotalPrice);
const estimate = computed(() => estimateStore.estimate);
const estimateSubtotal = computed(() => estimate.value.subtotal);
const dealType = computed(() => estimateStore.estimate.dealTypeCode);

const pricingService = new PricingService();
watch(
  () => [
    estimateStore.estimate.estimatePrice,
    installationStore.totalInstallationSum,
    deliveryStore.totalDeliveryPrice,
  ],
  () => {
    const subtotal = pricingService.calculateSubtotalEstimateReviewPrice();

    const subTotalPrice = new Pricing(
      subtotal.price,
      subtotal.priceB2C,
      subtotal.priceB2B,
    );

    estimateReviewStore.subtotalPrice = subTotalPrice;
    estimateStore.estimate.totalWithoutTax = subTotalPrice
      .getSystemPrice(dealType.value)
      .getValue();
  },
  { deep: true, immediate: true },
);
</script>

<style lang="scss" scoped>
.step__block-field {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 24px;
  padding: 24px 0 15px;
  border-top: 1px solid #d2d8e3;
  border-bottom: 1px solid #d2d8e3;
}

.step__block-field h3 {
  color: #404d63;
  font-family: Gilroy;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}

.step__block-field-price {
  color: #404d63;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}

.step__block-field-price.old-price {
  display: flex;
  align-items: center;
  column-gap: 4px;
  min-width: max-content;

  font-family: Gilroy;
  color: #404d63bf;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  text-transform: uppercase;
  text-decoration: line-through;
}

.step__block-field-price.right {
  display: block;
  width: 100%;

  text-align: right;
  line-height: 20px;
}

.step__block-field-price.container {
  display: flex;
  column-gap: 10px;
  align-items: flex-end;
}
</style>
